import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5927%3A6681
 *
 * @param {SvgIconProps} props - svg props
 */
export const OpenInNewIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M19 18.5C19 18.7761 18.7761 19 18.5 19H5.5C5.22386 19 5 18.7761 5 18.5V5.5C5 5.22386 5.22386 5 5.5 5H10.5C10.7761 5 11 4.77614 11 4.5V3.5C11 3.22386 10.7761 3 10.5 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V13.5C21 13.2239 20.7761 13 20.5 13H19.5C19.2239 13 19 13.2239 19 13.5V18.5Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M14.4999 3.5V4.5C14.4999 4.77614 14.7237 5 14.9999 5H18.2499L12.0324 11.2175C11.8372 11.4128 11.8372 11.7294 12.0324 11.9246C12.2277 12.1199 12.5443 12.1199 12.7395 11.9246L18.9999 5.6643V9C18.9999 9.27614 19.2237 9.5 19.4999 9.5H20.4999C20.776 9.5 20.9999 9.27614 20.9999 9V3.5C20.9999 3.22386 20.776 3 20.4999 3H14.9999C14.7237 3 14.4999 3.22386 14.4999 3.5Z' fill={color}/>
        </SvgIcon>
    )
}

export default OpenInNewIcon
